
<div class="main-container">
	<h3>{{ errorTitle }}</h3>
	<div class="error-container">
		<p [innerHTML]="errorMessage"></p>
		<button mat-flat-button (click)="redirectToLogin()">Back to login</button>
	</div>
</div>